"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import Loading from "@components/common/loading";
import type { TwitterResult } from "@lib/api/wikidata/types";
interface Props {
  twitterFeed?: TwitterResult;
}
export default function TwitterFeed(t0) {
  const $ = _c(12);
  const {
    twitterFeed
  } = t0;
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  let t1;
  if ($[0] !== theme.theme || $[1] !== twitterFeed?.twitterHandle.value) {
    t1 = () => {
      const twitterHandle = twitterFeed?.twitterHandle.value;
      if (twitterHandle) {
        setLoading(true);
        const container = document.getElementById("twitterContainer");
        if (container) {
          container.innerHTML = "";
        }
        window.twttr.widgets?.createTimeline({
          sourceType: "profile",
          screenName: twitterHandle
        }, container, {
          theme: theme.theme as "light" | "dark",
          chrome: "nofooter noborders"
        }).then(() => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    };
    $[0] = theme.theme;
    $[1] = twitterFeed?.twitterHandle.value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = twitterFeed?.twitterHandle.value;
  let t3;
  if ($[3] !== t2 || $[4] !== theme.theme) {
    t3 = [theme.theme, t2];
    $[3] = t2;
    $[4] = theme.theme;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  const twitterHandle_0 = twitterFeed?.twitterHandle.value;
  if (!twitterHandle_0) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="m-4"><p className="text-center text-lg">Inget Twitterkonto hittades.</p></div>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div id="twitterContainer" className="mx-auto my-4 max-w-[500px] bg-black" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== loading) {
    t5 = loading && <Loading className="mx-auto my-8" />;
    $[8] = loading;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}